import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import qs from 'qs';

import {
  Button,
  Toast,
  ToastContainer,
  Spinner,
  Input,
  Modal
} from '@salesforce/design-system-react';
import activateImg from './images/activate.png';
import waitingImg from './images/activate-waiting.png';
import './ActivateContent.scss';

export class ActivateContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toastOpen: false,
      toastType: '',
      toastText: {
        heading: null,
        details: null
      },
      isWaiting: false,
      isActivated: false,
      toDashboard: false,
      notifyEmail: {
        value: '',
        isValid: null
      }
    };
  }

  componentDidMount() {
    this.getActivation();
    this.getFrequencies();
  }

  componentDidUpdate(prevProps) {
    const { activation, frequencies, notificationSubscribers } = this.props;
    let isActivated = activation.mid;

    // get frequencies if mid isActivated
    if (prevProps.activation.mid !== activation.mid) {
      const redirectToWaiting = true;
      isActivated = activation.mid;
      this.setState({ isActivated: Boolean(isActivated) });
      this.getFrequencies(redirectToWaiting);
    }

    // update state.isWaiting if frequencies don't exist
    if (
      prevProps.frequencies.isLoading !== frequencies.isLoading &&
      !frequencies.isLoading
    ) {
      if (
        (frequencies.error || !frequencies.data.frequencies.length) &&
        isActivated
      ) {
        this.setState({ isWaiting: true });
      } else if (
        frequencies.data.frequencies.length &&
        !frequencies.error &&
        isActivated
      ) {
        let parsedQueryString = qs.parse(this.props.location.search.substr(1));
        parsedQueryString.useMockData =
          parsedQueryString.useMockActivation === 'true' ? 'true' : null;
        const queryString = `?${qs.stringify(parsedQueryString)}`;
        this.props.history.push(`/${queryString}`);
      }
    }

    // update notificationSubscribers in component state
    if (
      prevProps.notificationSubscribers !== notificationSubscribers &&
      !notificationSubscribers.isLoading
    ) {
      const value = notificationSubscribers.emails.length
        ? notificationSubscribers.emails[0].email
        : '';
      if (value !== '') {
        this.setState({
          notifyEmail: {
            value,
            isValid: true
          }
        });
      }
      // open toast if notify email address saved successfully
      if (
        prevProps.notificationSubscribers.submitSaveSuccess !==
          notificationSubscribers.submitSaveSuccess &&
        notificationSubscribers.submitSaveSuccess
      ) {
        this.openToast('submitEmailSuccess');
      }
    }
  }

  getFrequencies(redirectToWaiting = false, useMockData) {
    const { dataFilter } = this.props;
    const parsedQueryString = qs.parse(this.props.location.search.substr(1));
    const options = {
      ...parsedQueryString,
      useMockData:
        useMockData && parsedQueryString.useMockActivation === 'true'
          ? 'true'
          : null,
      onError: redirectToWaiting ? this.handleError('activateSuccess') : null
    };
    this.props.actions.getFrequenciesData(options, dataFilter);
  }

  getActivation() {
    const queryString = this.props.location.search.substr(1);
    const parsedQueryString = qs.parse(queryString);
    const options = {
      ...parsedQueryString
    };
    this.props.actions.getActivationStatus(options);
  }

  handleActivate() {
    const parsedQueryString = qs.parse(this.props.location.search.substr(1));
    const options = {
      ...parsedQueryString,
      onError: this.handleError('activateError')
    };
    this.props.actions.submitActivation(options);
  }

  openToast(type) {
    this.closeToast();
    const { formatMessage } = this.props.intl;
    const typeMap = {
      activateError: {
        toastOpen: true,
        toastType: 'error',
        toastText: {
          heading: formatMessage({
            id: `ActivateContent.toasts.activateError.heading`
          }),
          details: null
        }
      },
      activateSuccess: {
        isActivated: true,
        toastOpen: true,
        toastType: 'success',
        toastText: {
          heading: formatMessage({
            id: `ActivateContent.toasts.activateSuccess.heading`
          }),
          details: formatMessage({
            id: `ActivateContent.toasts.activateSuccess.details`
          })
        }
      },
      invalidEmail: {
        toastOpen: true,
        toastType: 'error',
        toastText: {
          heading: formatMessage({
            id: `ActivateContent.toasts.invalidEmail.heading`
          }),
          details: null
        }
      },
      submitEmailError: {
        toastOpen: true,
        toastType: 'error',
        toastText: {
          heading: formatMessage({
            id: `ActivateContent.toasts.submitEmailError.heading`
          }),
          details: null
        }
      },
      submitEmailSuccess: {
        toastOpen: true,
        toastType: 'success',
        toastText: {
          heading: formatMessage({
            id: `ActivateContent.toasts.submitEmailSuccess.heading`
          }),
          details: formatMessage({
            id: `ActivateContent.toasts.submitEmailSuccess.details`
          })
        }
      }
    };
    this.setState({
      ...typeMap[type]
    });
  }

  closeToast() {
    this.setState({ toastOpen: false });
  }

  handleError(type) {
    return error => {
      if (error && error.response) {
        this.openToast(type);
      }
    };
  }

  handleOpenModal() {
    this.props.actions.openModal('notifyMeWhenReady');
  }

  handleCloseModal() {
    this.props.actions.closeModal('notifyMeWhenReady');
  }

  validateEmail(email) {
    const re = /^\S+@\S+$/;
    return re.test(email);
  }

  handleEmailChange(e, v) {
    const value = v.value;
    this.setState({
      notifyEmail: {
        isValid: null,
        value
      }
    });
  }

  handleEmailOnBlur(e, v) {
    const isValid = this.validateEmail(this.state.notifyEmail.value);
    this.setState({
      notifyEmail: {
        ...this.state.notifyEmail,
        isValid
      }
    });
  }

  handleSubmitEmail() {
    const { value, isValid } = this.state.notifyEmail;
    const parsedQueryString = qs.parse(this.props.location.search.substr(1));
    let options = {
      ...parsedQueryString,
      onError: this.handleError('submitEmailError')
    };
    const subscribers = {
      notificationSubscribers: [{ email: value }]
    };
    if (isValid) {
      this.props.actions.submitUpdateNotificationEmail(options, subscribers);
      this.handleCloseModal();
    } else {
      this.openToast('invalidEmail');
    }
  }

  renderToast() {
    const toastType = this.state.toastType;
    const labels = {
      heading: this.state.toastText.heading,
      details: this.state.toastText.details
    };
    return (
      <ToastContainer>
        <Toast
          labels={labels}
          variant={toastType}
          duration={5000}
          onRequestClose={() => this.closeToast()}
        />
      </ToastContainer>
    );
  }

  renderSpinner() {
    return (
      <div>
        <Spinner variant="brand" />
      </div>
    );
  }

  renderActivate() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="slds-col activate-content-container">
        <img
          className="activate-img"
          src={activateImg}
          alt={formatMessage({ id: 'ActivateContent.start.imageAltText' })}
        />
        <h1 className="activate-heading">
          <FormattedMessage id="ActivateContent.start.title" />
        </h1>
        <p className="activate-description">
          <FormattedMessage id="ActivateContent.start.description" />
        </p>
        <Button
          className="activate-button"
          label={formatMessage({ id: 'ActivateContent.start.button' })}
          variant="brand"
          onClick={() => this.handleActivate()}
        />
      </div>
    );
  }

  renderWaiting() {
    const { formatMessage } = this.props.intl;
    const isOpen = Boolean(
      this.props.modals.notifyMeWhenReady &&
        this.props.modals.notifyMeWhenReady.isOpen
    );
    return (
      <div className="slds-col activate-content-container waiting">
        <img
          className="activate-img"
          src={waitingImg}
          alt={formatMessage({ id: 'ActivateContent.waiting.imageAltText' })}
        />
        <h1 className="activate-heading">
          <FormattedMessage id="ActivateContent.waiting.title" />
        </h1>
        <p className="activate-description">
          <FormattedMessage id="ActivateContent.waiting.description" />
        </p>
        <Button
          className="activate-button"
          label={formatMessage({ id: 'ActivateContent.waiting.button' })}
          variant="neutral"
          onClick={() => this.handleOpenModal()}
        />
        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.handleCloseModal()}
          title={formatMessage({ id: 'ActivateContent.waiting.modal.title' })}
          footer={[
            <Button
              label={formatMessage({
                id: 'ActivateContent.waiting.modal.actions.cancel'
              })}
              onClick={() => this.handleCloseModal()}
            />,
            <Button
              variant="brand"
              label={formatMessage({
                id: 'ActivateContent.waiting.modal.actions.submit'
              })}
              onClick={() => this.handleSubmitEmail()}
            />
          ]}
        >
          <section className="notification-modal-body">
            <p className="notification-modal-description">
              {formatMessage({
                id: 'ActivateContent.waiting.modal.description'
              })}
            </p>
            <Input
              id="notificationEmails"
              value={this.state.notifyEmail.value}
              placeholder={formatMessage({
                id: 'ActivateContent.waiting.modal.placeholder'
              })}
              errorText={
                this.state.notifyEmail.value !== '' &&
                this.state.notifyEmail.isValid === false
                  ? formatMessage({
                      id: 'ActivateContent.waiting.modal.errorText'
                    })
                  : null
              }
              onChange={(e, v) => this.handleEmailChange(e, v)}
              onBlur={(e, v) => this.handleEmailOnBlur(e, v)}
            />
          </section>
        </Modal>
      </div>
    );
  }

  render() {
    const { activation } = this.props;
    const isLoading = activation && activation.isLoading;

    return (
      <div className="activate-content">
        {activation && isLoading ? this.renderSpinner() : null}
        <div className="slds-grid slds-grid_align-center">
          {!this.state.isWaiting ? this.renderActivate() : this.renderWaiting()}
        </div>
        {this.state.toastOpen ? this.renderToast() : null}
      </div>
    );
  }
}

ActivateContent.propTypes = {
  activation: PropTypes.object.isRequired,
  dataFilter: PropTypes.object.isRequired,
  frequencies: PropTypes.object.isRequired,
  notificationSubscribers: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  history: PropTypes.object,
  actions: PropTypes.object.isRequired,
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(ActivateContent);
